/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AccionAsync as AccionAsync,
  rec_Bo as Bo,
  rec_CodigoVinculacion as CodigoVinculacion,
  rec_Fo as Fo,
  rec_Go as Go,
  rec_Hi as Hi,
  rec_JSXRuntime as JSXRuntime,
  rec_QrVinculacion as QrVinculacion,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_VincularBot as VincularBot,
  rec_VincularPorTelefono as VincularPorTelefono,
  rec_api as api,
  rec_nQ as nQ,
  rec_pS as pS,
  rec_rQ as rQ,
  rec_tQ as tQ,
  rec_uS as uS,
} from "../../runtime/index.jsx";
export function TarjetaBot(e) {
  let t = (0, ReactCompiler.c)(57),
    { bot: n, onCambio: r } = e,
    i = Go(),
    { confirmar: a } = Fo(),
    o;
  t[0] === n ? (o = t[1]) : ((o = tQ(n)), (t[0] = n), (t[1] = o));
  let s = o,
    c = n.enLinea && n.estado === `conectado`,
    l;
  t[2] === n.telefono
    ? (l = t[3])
    : ((l = rQ(n.telefono)), (t[2] = n.telefono), (t[3] = l));
  let u = l,
    d;
  t[4] !== i ||
  t[5] !== n.id ||
  t[6] !== c ||
  t[7] !== a ||
  t[8] !== u ||
  t[9] !== r
    ? ((d = async function () {
        if (
          await a({
            titulo: `Vincular otro teléfono`,
            mensaje:
              c && u
                ? `El bot deja de responder en ${u} hasta que se escanee el código nuevo.`
                : `Se prepara un código nuevo para escanear.`,
            confirmarTexto: `Vincular otro`,
            peligro: c,
          })
        )
          try {
            (await api(`/bots/${n.id}/desvincular`, {
              method: `POST`,
            }),
              i.ok(`En unos segundos aparece el código nuevo`),
              await r());
          } catch (e) {
            let t = e;
            i.error(t.message);
          }
      }),
      (t[4] = i),
      (t[5] = n.id),
      (t[6] = c),
      (t[7] = a),
      (t[8] = u),
      (t[9] = r),
      (t[10] = d))
    : (d = t[10]);
  let f = d,
    p;
  t[11] === n.nombre
    ? (p = t[12])
    : ((p = (
        <h2
          className={`!m-0 text-base font-semibold text-(--text-h)`}
          children={n.nombre}
        />
      )),
      (t[11] = n.nombre),
      (t[12] = p));
  let m = `shrink-0 rounded-full px-2.5 py-0.5 text-xs font-medium ${nQ[s.tono]}`,
    h;
  t[13] !== s.texto || t[14] !== m
    ? ((h = <span className={m} children={s.texto} />),
      (t[13] = s.texto),
      (t[14] = m),
      (t[15] = h))
    : (h = t[15]);
  let _;
  t[16] !== p || t[17] !== h
    ? ((_ = (
        <div
          className={`flex items-start justify-between gap-2`}
          children={[p, h]}
        />
      )),
      (t[16] = p),
      (t[17] = h),
      (t[18] = _))
    : (_ = t[18]);
  let v;
  t[19] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((v = <dt className={`text-(--text)`} children={`Número`} />),
      (t[19] = v))
    : (v = t[19]);
  let y = u ?? `Sin número vinculado`,
    b;
  t[20] === y
    ? (b = t[21])
    : ((b = <dd className={`text-(--text-h)`} children={y} />),
      (t[20] = y),
      (t[21] = b));
  let x;
  t[22] === n.conectadoEn
    ? (x = t[23])
    : ((x = n.conectadoEn && (
        <JSXRuntime.Fragment
          children={[
            <dt className={`text-(--text)`} children={`Conectado desde`} />,
            <dd className={`text-(--text-h)`} children={pS(n.conectadoEn)} />,
          ]}
        />
      )),
      (t[22] = n.conectadoEn),
      (t[23] = x));
  let S;
  t[24] !== n.estado || t[25] !== n.ultimoMensajeEn
    ? ((S = n.estado !== `sin-datos` && (
        <JSXRuntime.Fragment
          children={[
            <dt className={`text-(--text)`} children={`Último mensaje`} />,
            <dd
              className={`text-(--text-h)`}
              children={
                n.ultimoMensajeEn
                  ? uS(n.ultimoMensajeEn)
                  : `Todavía no recibió mensajes`
              }
            />,
          ]}
        />
      )),
      (t[24] = n.estado),
      (t[25] = n.ultimoMensajeEn),
      (t[26] = S))
    : (S = t[26]);
  let C;
  t[27] !== b || t[28] !== x || t[29] !== S
    ? ((C = (
        <dl
          className={`grid grid-cols-[auto_1fr] gap-x-3 gap-y-1 text-sm`}
          children={[v, b, x, S]}
        />
      )),
      (t[27] = b),
      (t[28] = x),
      (t[29] = S),
      (t[30] = C))
    : (C = t[30]);
  let w;
  t[31] === n
    ? (w = t[32])
    : ((w = <VincularBot bot={n} />), (t[31] = n), (t[32] = w));
  let T;
  t[33] !== n.codigo || t[34] !== n.desvinculacionPendiente
    ? ((T = n.codigo && !n.desvinculacionPendiente && (
        <CodigoVinculacion codigo={n.codigo} />
      )),
      (t[33] = n.codigo),
      (t[34] = n.desvinculacionPendiente),
      (t[35] = T))
    : (T = t[35]);
  let E;
  t[36] !== n.codigo || t[37] !== n.desvinculacionPendiente || t[38] !== n.qr
    ? ((E = n.qr && !n.codigo && !n.desvinculacionPendiente && (
        <QrVinculacion qr={n.qr} />
      )),
      (t[36] = n.codigo),
      (t[37] = n.desvinculacionPendiente),
      (t[38] = n.qr),
      (t[39] = E))
    : (E = t[39]);
  let D;
  t[40] !== n || t[41] !== r
    ? ((D = !n.telefono &&
        !n.desvinculacionPendiente &&
        n.enLinea &&
        n.estado !== `conectado` &&
        n.estado !== `sin-datos` && (
          <VincularPorTelefono bot={n} onCambio={r} />
        )),
      (t[40] = n),
      (t[41] = r),
      (t[42] = D))
    : (D = t[42]);
  let O;
  t[43] !== n.desvinculacionPendiente ||
  t[44] !== n.estado ||
  t[45] !== c ||
  t[46] !== f
    ? ((O = n.estado !== `sin-datos` && (
        <div
          className={`flex justify-end`}
          children={
            <AccionAsync
              variante={c ? `peligro` : `primario`}
              className={`min-h-11`}
              icono={Hi}
              disabled={n.desvinculacionPendiente}
              onClick={f}
              children={`Vincular otro teléfono`}
            />
          }
        />
      )),
      (t[43] = n.desvinculacionPendiente),
      (t[44] = n.estado),
      (t[45] = c),
      (t[46] = f),
      (t[47] = O))
    : (O = t[47]);
  let k;
  return (
    t[48] !== n.nombre ||
    t[49] !== C ||
    t[50] !== w ||
    t[51] !== T ||
    t[52] !== E ||
    t[53] !== D ||
    t[54] !== O ||
    t[55] !== _
      ? ((k = (
          <section
            className={`${Bo} flex flex-col gap-3`}
            aria-label={n.nombre}
            children={[_, C, w, T, E, D, O]}
          />
        )),
        (t[48] = n.nombre),
        (t[49] = C),
        (t[50] = w),
        (t[51] = T),
        (t[52] = E),
        (t[53] = D),
        (t[54] = O),
        (t[55] = _),
        (t[56] = k))
      : (k = t[56]),
    k
  );
}
